import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ShieldCheck, Menu, X, ChevronDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";

const NAV = [
  { label: "Services", to: "/services" },
  { label: "Find Agencies", to: "/agencies" },
  { label: "How It Works", to: "/how-it-works" },
  { label: "For Agencies", to: "/for-agencies" },
  { label: "Pricing", to: "/pricing" },
];

export function Logo({ light }) {
  return (
    <Link to="/" className="flex items-center" data-testid="logo-home-link">
      <img src="/guarddekho-logo.webp" alt="GuardDekho.com — Security Guard Marketplace"
        className={`h-20 sm:h-24 w-auto object-contain ${light ? "bg-white rounded-lg px-3 py-2" : ""}`} />
    </Link>
  );
}

export default function PublicNav() {
  const [open, setOpen] = useState(false);
  const { user } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const dashPath = user?.roles?.includes("admin") ? "/admin"
    : user?.roles?.includes("agency") && user?.active_role === "agency" ? "/agency" : "/dashboard";

  return (
    <header className="sticky top-0 z-50 glass-nav border-b border-navy-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 h-28 flex items-center justify-between">
        <div className="flex items-center gap-8">
          <Logo />
          <nav className="hidden lg:flex items-center gap-6">
            {NAV.map((n) => (
              <Link key={n.to} to={n.to} data-testid={`nav-${n.to.slice(1)}`}
                className={`text-sm font-medium transition-colors hover:text-brand ${location.pathname === n.to ? "text-brand" : "text-navy-700"}`}>
                {n.label}
              </Link>
            ))}
          </nav>
        </div>
        <div className="hidden lg:flex items-center gap-3">
          {user ? (
            <Link to={dashPath}><Button className="bg-navy-900 hover:bg-navy-800" data-testid="nav-dashboard-btn">Dashboard</Button></Link>
          ) : (
            <>
              <Button variant="ghost" className="text-navy-700 hover:text-brand" onClick={() => navigate("/login")} data-testid="nav-login-btn">Log in</Button>
              <Button variant="outline" className="border-brand text-brand hover:bg-brand hover:text-white bg-transparent" onClick={() => navigate("/register-agency")} data-testid="nav-register-agency-btn">Register Agency</Button>
              <Button className="bg-brand hover:bg-brand-600 text-white" onClick={() => navigate("/login")} data-testid="nav-getstarted-btn">Get Started</Button>
            </>
          )}
        </div>
        <button className="lg:hidden text-navy-900" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle">
          {open ? <X /> : <Menu />}
        </button>
      </div>
      {open && (
        <div className="lg:hidden bg-white border-t border-navy-200 px-4 py-4 space-y-2">
          {NAV.map((n) => (
            <Link key={n.to} to={n.to} onClick={() => setOpen(false)} className="block py-2 text-navy-700 font-medium">{n.label}</Link>
          ))}
          {user ? (
            <Link to={dashPath}><Button className="w-full bg-navy-900">Dashboard</Button></Link>
          ) : (
            <div className="space-y-2">
              <Button variant="outline" className="w-full border-brand text-brand bg-transparent" onClick={() => { setOpen(false); navigate("/register-agency"); }} data-testid="nav-mobile-register-agency">Register Agency</Button>
              <Button className="w-full bg-brand hover:bg-brand-600" onClick={() => { setOpen(false); navigate("/login"); }}>Get Started</Button>
            </div>
          )}
        </div>
      )}
    </header>
  );
}
